export enum VoucherStatus {
  VALID = "VALID",
  EXPIRED = "EXPIRED",
  VOUCHER_CAPACITY_EXCEEDED = "VOUCHER_CAPACITY_EXCEEDED",
}
export enum VoucherStatusToShow {
  VALID = "enumMapping.voucher.VALID",
  EXPIRED = "enumMapping.voucher.EXPIRED",
  VOUCHER_CAPACITY_EXCEEDED = "enumMapping.voucher.VOUCHER_CAPACITY_EXCEEDED"
}

export const VoucherStatusMapping: Record<VoucherStatus, string> = {
  [VoucherStatus.VALID]: "filter.voucherFilter.VALID",
  [VoucherStatus.EXPIRED]: "filter.voucherFilter.EXPIRED",
  [VoucherStatus.VOUCHER_CAPACITY_EXCEEDED]: "filter.voucherFilter.VOUCHER_CAPACITY_EXCEEDED",
};

/*export enum VoucherFilterStatusToShow {
  VALID = "filter.voucherFilter.VALID",
  EXPIRED = "filter.voucherFilter.EXPIRED",
  VOUCHER_CAPACITY_EXCEEDED = "filter.voucherFilter.VOUCHER_CAPACITY_EXCEEDED"
}*/

export interface VoucherStatusInterface {
  id: VoucherStatus;
  value: string;
}
